import { makeStyles } from '@mui/styles'
import idsTheme, { defaultPalette } from '../../../../theme/idsTheme'

const theme = idsTheme()

export default makeStyles(() => ({
    PatientForm: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    PatientFormContainer: {
        padding: '1.5rem',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        [theme.breakpoints.up('sm')]: {
            padding: '3.5rem',
        },
    },
    PatientFormContainerExternal: {
        background: '#ffffff',
        overflow: 'hidden',
    },
    PatientFormHeader: {
        marginBottom: '2.5rem',
    },
    PatientFormHeaderTitleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem',
    },
    PatientFormHeaderTexts: {
        marginBottom: '1.7rem',
    },
    PatientFormHeaderTitle: {
        fontSize: '1.3rem',
        fontWeight: 700,
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.75rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '2.75rem',
        },
    },
    PatientFormHeaderSubTitle: {
        color: defaultPalette.lightGrey.hard,
    },
    PatientFormBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2.5rem',
    },
    PatientFormDisclamerButton: {
        padding: '.4rem',
        borderRadius: '.5rem',
        color: defaultPalette.orangeWarning.main,
        textDecoration: 'underline',
    },
}))
